export class AbortableRequest {
  private controller: AbortController | null = null;

  abort() {
    this.controller?.abort();
    this.controller = null;
  }

  start(): AbortSignal {
    this.abort();
    this.controller = new AbortController();
    return this.controller.signal;
  }

  complete() {
    this.controller = null;
  }

  get aborted() {
    return this.controller?.signal.aborted ?? false;
  }
}

export type PaginatedPageResult<TItem> = {
  items: TItem[];
  nextToken?: string;
};

export async function fetchAllPaginated<TItem>({
  fetchPage,
  initialItems = [],
  initialNextToken,
}: {
  fetchPage: (nextToken?: string) => Promise<PaginatedPageResult<TItem>>;
  initialItems?: TItem[];
  initialNextToken?: string;
}): Promise<TItem[]> {
  const items = [...initialItems];
  let nextToken: string | undefined = initialNextToken;

  do {
    const page = await fetchPage(nextToken);
    items.push(...page.items);
    nextToken = page.nextToken;
  } while (nextToken);

  return items;
}
